import type { GameMode } from '../core/types/gameMode.types';
import { demoEcuacionesPayload, demoGobernabilidadPayload } from '../activities/sandbox/sandbox.logic';
import {
  demoAnagramPayload,
  demoChainPayload,
  demoMelodySketchPayload,
  demoPictionaryPayload,
} from '../activities/coop/coop.demos';
import { demoPartituraPayload } from '../activities/pinpoint/pinpoint.logic';
import { demoEstructuraMusicalPayload } from '../activities/sequencer/sequencer.logic';

export interface ActivityPreset {
  id: string;
  title: string;
  description: string;
  mode: GameMode;
  subjectTag: string;
  icon: string;
  payload: () => unknown;
}

export const ACTIVITY_PRESETS: ActivityPreset[] = [
  {
    id: 'sandbox-ecuaciones',
    title: 'Balanza de Ecuaciones',
    description: 'Mueve incógnitas (x, y) de un lado a otro para despejar el sistema visualmente.',
    mode: 'sandbox',
    subjectTag: 'matematica',
    icon: '⚖️',
    payload: demoEcuacionesPayload,
  },
  {
    id: 'coop-anagram',
    title: 'Fábrica de Anagramas',
    description: 'Combina letras compartidas del equipo para descubrir la palabra oculta.',
    mode: 'coop',
    subjectTag: 'lenguaje',
    icon: '🔤',
    payload: demoAnagramPayload,
  },
  {
    id: 'coop-chain',
    title: 'Conectores en Cadena',
    description: 'Cada alumno aporta el conector lógico que falta en su turno.',
    mode: 'coop',
    subjectTag: 'lenguaje',
    icon: '🔗',
    payload: demoChainPayload,
  },
  {
    id: 'coop-pictionary',
    title: 'Pictionary Conceptual',
    description: 'Un alumno dibuja un concepto abstracto; la sala conjetura en vivo.',
    mode: 'coop',
    subjectTag: 'artes',
    icon: '🎨',
    payload: demoPictionaryPayload,
  },
  {
    id: 'sandbox-governance',
    title: 'Gobernabilidad en Crisis',
    description: 'Mantén a flote el índice de aprobación gestionando recursos ante crisis históricas.',
    mode: 'sandbox',
    subjectTag: 'historia',
    icon: '🏛️',
    payload: demoGobernabilidadPayload,
  },
  {
    id: 'pinpoint-partitura',
    title: 'Mapa de la Partitura',
    description: 'Toca la nota o símbolo exacto en la partitura proyectada.',
    mode: 'point',
    subjectTag: 'musica',
    icon: '🎼',
    payload: demoPartituraPayload,
  },
  {
    id: 'sequencer-estructura',
    title: 'Secuencias de Estructura',
    description: 'Ordena bloques estructurales de una canción (Intro, Estrofa, Coro, Solo, Outro).',
    mode: 'order',
    subjectTag: 'musica',
    icon: '🕒',
    payload: demoEstructuraMusicalPayload,
  },
  {
    id: 'coop-melody-sketch',
    title: 'Lienzo del Sonido',
    description: 'Dibuja el contorno melódico de un fragmento para que los compañeros adivinen.',
    mode: 'coop',
    subjectTag: 'musica',
    icon: '🎵',
    payload: demoMelodySketchPayload,
  },
];

export function getActivityPreset(id: string): ActivityPreset | undefined {
  return ACTIVITY_PRESETS.find((p) => p.id === id);
}
